import React, { useState } from "react";
import { ChiTietTaiSan1 } from "../ChiTiet/ChiTietTaiSan";
export const BtnChiTietTaiSan = ({ item }) => {
  const [showChiTietTaiSan, setShowChiTietTaiSan] = useState(false);
  const handleCloseChiTietTaiSan = () => setShowChiTietTaiSan(false);
  const handleShowChiTietTaiSan = () => setShowChiTietTaiSan(true);
  const functionChiTietTaiSan = () => {
    setShowChiTietTaiSan(true);
  };

  return (
    <>
      <a
        onClick={functionChiTietTaiSan}
        href={() => false}
        className="blue word-break btn-link"
      >
        {item.MaTaiSan}
      </a>
      {showChiTietTaiSan && (
        <ChiTietTaiSan1
          show={showChiTietTaiSan}
          taiSanId={item.TaiSanID}
          onHide={handleCloseChiTietTaiSan}
        ></ChiTietTaiSan1>
      )}
    </>
  );
};
